import { render } from "./B2bPageAuditoriaDocumento.vue?vue&type=template&id=12001212&scoped=true&lang=pug"
import script from "./B2bPageAuditoriaDocumento.vue?vue&type=script&lang=js"
export * from "./B2bPageAuditoriaDocumento.vue?vue&type=script&lang=js"

import "./B2bPageAuditoriaDocumento.vue?vue&type=style&index=0&id=12001212&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12001212"]])

export default __exports__